export const ESubAdminRoles = {
	OPS: 'ops',
	FINANCE: 'finance',
	FIN_AUDITOR: 'fin_auditor'
};

export const searchOptions = [
	{ value: 'name', label: 'User Name' },
	{ value: 'email', label: 'User Email' }
];

export const userRoleEnum = [
	{
		label: 'Ops',
		value: ESubAdminRoles.OPS
	},
	{
		label: 'Finance',
		value: ESubAdminRoles.FINANCE
	},
	{
		label: 'Finance Auditor',
		value: ESubAdminRoles.FIN_AUDITOR
	}
];
